import * as types from "../types";

export const setFilterBar = (filterBar) => {
  return { type: types.GENERAL_SET_FILTER_BAR, data: filterBar };
};
